import compressCasePicture from './compressCasePicture';

// The logo a company is created with travels as these bytes; nothing downstream compresses it again
const compressedLogoBase64 = async (file) => {
  const compressed = await compressCasePicture(file);
  if (!compressed) return undefined;

  const buffer = await compressed.arrayBuffer();
  const binary = new Uint8Array(buffer).reduce(
    (text, byte) => (text + String.fromCharCode(byte)),
    '',
  );

  return {
    mime: compressed.type,
    base64: btoa(binary),
  };
};

export default compressedLogoBase64;
